import { MakeStringValues, Translations } from "../translations.type";

export const enTranslations: MakeStringValues<Translations> = {
  "Trascina qui un'immagine o clicca per caricarne una!":
    "Drag an image here or click to upload one",
  "Registra una nuova attivit\u00E1!": "Insert a new shop",
  Annulla: "Cancel",
  Aggiungi: "Add",
  Banner: "Banner",
  Testi: "Texts",
  Orari: "Timetable",
  "Banner dell'evento": "Event banner",
  Titolo: "Title",
  Contenuto: "Content",
  "Data di inizio": "Valid from",
  "Fino al": "Expire",
  "Crea Evento": "Create Event",
  Applica: "Apply",
  Nome: "Name",
  Gestione: "Manage",
  "Log out": "Log out",
  "Crea una promozione di benvenuto!": "Create a welcome promotion!",
  "Durata promozione": "Promo duration",
  Anteprima: "Preview",
  Modifica: "Modify",
  "Giorni alla scadenza": "days to expiration",
  Crea: "Create",
  "Ore alla scadenza": "hours to expiration",
  "Minuti alla scadenza": "Minutes to expiration",
  Descrizione: "Description",
  "Descrizione:": "Description:",
  Salva: "Save",
  "Data di fine": "Expiration date",
  Chiudi: "Close",
  "Breve descrizione della promozione": "Promo description",
  " Minuti": " Minutes ",
  " Giorni ": " Days ",
  " Ore ": " Hours ",
  Scadenza: "Expiration",
  "Valida fino al giorno ": "Expiration Date",
  "Qui ci sar\u00E1 la descrizione del tuo negozio, puoi modificarla nel pannello amministrativo!":
    "Here will be " +
    "your shop description, you can edit it in the admin section!",
  Gestisci: "Manage",
  "filtra tipologia": "type filter",
  Tutte: "All",
  Test: "Test",
  Produzione: "Production",
  "Invia una notifica": "Send notification",
  "Nuova notifica": "New notification",
  "Messaggio notifica": "Text notification",
  "Codice di verifica": "Verification code",
  "Conferma!": "Confirm!",
  "Registrandoti accetti i nostri": "Registrandoti accetti i nostri",
  "termini di servizio": "termini di servizio",
  "privacy policy": "privacy policy",
  "Iniziamo!": "Let's start",
  "Sei gi\u00E1 registrato?": "Already signed?",
  Accedi: "Login",
  "Devices Subscribed And Reached": "Devices Subscribed And Reached",
  "Confirm code!": "Confirm code!",
  "Entra!": "Come in!",
  "Non hai ancora un account?": "No account?",
  Registrati: "Sign Up",
  "Come Funziona": "How Does It Work",
  Prezzi: "Pricing",
  // HomePage
  "Fai crescere la tua attivit\u00E0 con Adhesion":
    "Grow your activity with Adhesion",
  "Richiama istantaneamente i tuoi clienti e offri loro le tue promozioni":
    "Instantly call back your customers and offer them your promotions",
  "Inizia subito": "Start now",
  // HeroSections
  "Notifica i tuoi clienti quando crei le tue promozioni":
    "Notify your customers as soon as a new promotion is created",
  "Adhesion sfrutta la tecnologia delle notifiche push per avvisare i tuoi clienti e offrire loro sconti e agevolazioni":
    "Adhesion leverages push notification technology to alert your customers and offer them discounts and benefits",
  "Raddoppia le vendite gi\u00E0 dal primo mese di utilizzo":
    "Double sales already from the first month of use",
  "Adhesion \u00E8 un'app nativa in abbonamento senza vincoli di tempo adatta ad ogni tipo di attivit\u00E0 commerciale":
    "Adhesion is a native subscription app with no time constraints suitable for any type of business",
  "Parti col piede giusto": "Get off on the right foot",
  "Adhesion \u00E8 in super promozionale iniziale e totalmente gratuito, ma non lo sar\u00E0 per sempre! Registrandoti ora diventerai un affiliato gratuito per sempre!":
    "Adhesion is in an initial super promotion and totally free, but it won't be forever! By registering now you will become a free affiliate forever!",
  // HowSection
  "Richiedi informazioni": "Request information",
  instruction1:
    "Signup now <1>for free</1> and start making your customers download the app right away.",
  instruction2:
    "Read the short user manual and build your user base. Follow our <1>marketing manual</1> and develop attractive promotions for your customers.",
  instruction3:
    "Analyze Adhesion's <1> weekly statistics </1> to see which promotions your customers perceive as most interesting.",
  instruction4:
    "<1>Compare your business revenue</1> before and after using Adhesion.",
  "Piani mensili proposti": "Plans and Pricing",
  mese: "month",
  promos: "1 promotion per week",
  promos_plural: "{{count}} promotions per week",
  devices: "1 device",
  devices_plural: "{{count}} devices",
  notis: "1 notification per week",
  notis_plural: "{{count}} notifications per week",
  "Domande frequenti": "Frequently Asked Questions",
  "Ti ricontatteremo subito": "Get a callback immediatly",
  // Contact form
  Email: "E-mail",
  Telefono: "Telephone",
  "\u002AFacolatativo": "\u002AOptional",
  "Voglio saperne di pi\u00F9": "I want to know more",
  "Le tue attivit\u00E0": "Your activities",
  "\u00C8 disponibile una nuova versione!": "A new version is available!",
  Aggiorna: "Update",
  "Sei attualmente offline. L'accesso all'applicazione potrebbe essere limitato.":
    "You are currently offline. Access to the application might be limited.",
  "Torna online per scaricare nuovi dati":
    "Come back online to download new data",
  Generali: "Generals",
  "Cerca tra i tuoi eventi con codice QR di attivazione":
    "Search your events with activation QR code",
  "Verifica codice QR": "QR code check",
  Eventi: "Events",
  "Centro Notifiche": "Notifications center",
  Statistiche: "Stats",
  Profilo: "Profile",
  Inizia: "Start",
};
